function Loader ({isLoading}) {
  return (<div className="loader" style = {{"display" : isLoading ? "block" : "none"}}></div>)
}
export default Loader;
